import * as mutations from '../store/mutations';
import * as constants from '../../common/constants';
import {mapGetters} from 'vuex';
import $ from 'jquery';

/**
 * Base of the CSS ClassName
 * @type {String}
 */
const recurrenceX1CssClassName = 'cta-recurrence-x1';
const recurrenceX2CssClassName = 'cta-recurrence-x2';
const recurrenceX3CssClassName = 'cta-recurrence-x3';

/**
 * Selector to retreive elements with the base className
 * @type {String}
 */
const recurrenceX1ElementSelector = `*[class*="${recurrenceX1CssClassName}"]`;
const recurrenceX2ElementSelector = `*[class*="${recurrenceX2CssClassName}"]`;
const recurrenceX3ElementSelector = `*[class*="${recurrenceX3CssClassName}"]`;

export default {
  data() {
    return {
      localeRecurrence: ''
    };
  },
  computed: {
    ...mapGetters([
      'recurrence'
    ])
  },
  created() {
    /**
     * Initialize localeRecurrence with the store one
     */
    this.localeRecurrence = this.$store.getters.recurrence;

    /**
     * Listen a click on a button to changer the paymentMethod
     */
    $('body').on('click', recurrenceX1ElementSelector, () => {
      $(recurrenceX1ElementSelector).addClass('active');
      $(recurrenceX2ElementSelector).removeClass('active');
      $(recurrenceX3ElementSelector).removeClass('active');
      this.$store.commit(mutations.SET_RECURRENCE, constants.RECURRENCE_X1);
    });

    $('body').on('click', recurrenceX2ElementSelector, () => {
      $(recurrenceX2ElementSelector).addClass('active');
      $(recurrenceX1ElementSelector).removeClass('active');
      $(recurrenceX3ElementSelector).removeClass('active');
      this.$store.commit(mutations.SET_RECURRENCE, constants.RECURRENCE_X2);
    });

    $('body').on('click', recurrenceX3ElementSelector, () => {
      $(recurrenceX3ElementSelector).addClass('active');
      $(recurrenceX1ElementSelector).removeClass('active');
      $(recurrenceX2ElementSelector).removeClass('active');

      this.$store.commit(mutations.SET_RECURRENCE, constants.RECURRENCE_X3);
    });
  },
  watch: {
    recurrence(value) {
      this.localeRecurrence = value;

      if (value === constants.RECURRENCE_X1) {
        $(recurrenceX1ElementSelector).addClass('active');
        $(recurrenceX2ElementSelector).removeClass('active');
        $(recurrenceX3ElementSelector).removeClass('active');
      } else if (value === constants.RECURRENCE_X2) {
        $(recurrenceX2ElementSelector).addClass('active');
        $(recurrenceX1ElementSelector).removeClass('active');
        $(recurrenceX3ElementSelector).removeClass('active');
      } else if (value === constants.RECURRENCE_X3) {
        $(recurrenceX3ElementSelector).addClass('active');
        $(recurrenceX1ElementSelector).removeClass('active');
        $(recurrenceX2ElementSelector).removeClass('active');
      }
    },
    localeRecurrence(value) {
      this.$store.commit(mutations.SET_RECURRENCE, value);
    }
  }
};



// WEBPACK FOOTER //
// ./src/multiple/controllers/recurrence.js